import GameBlock from "./GameBlock";
import style from "./style.less";
const HomeGameContainer = (props) => {
  let games = [];
  if (props.games) {
    games = props.games;
  }
  const onGameClick = (game) => {
    if (typeof props.onGameClick == "function") {
      props.onGameClick(game);
    }
  };
  return (
    <div class={style.game_container}>
      <div class={style.game_header_container}>
        <div ref={props.tabRef} class={style.game_header}>
          {props.icon && (
            <img src={props.icon} style={{ height: "1.39rem", marginLeft: "0.2rem", marginRight: "0.22rem", marginTop: "0.69rem" }} />
          )}
          <span> {props.name}</span>
        </div>
      </div>
      <div class={style.game_block_container}>
        {games.map((game) => {
          return <GameBlock key={game.id} game={game} onClick={() => onGameClick(game)} style={style} />;
        })}
      </div>
    </div>
  );
};

export default HomeGameContainer;
